import { Box } from "@mui/material";

// Default container for a worklist page
const DefaultWrapper = (props: any) => {
    return <Box sx={{ width: '100%', padding: 0, margin: 0 }}>{props.children}</Box>;
}

export default DefaultWrapper;